<template>
  <v-app class="bg-white">
    <v-main>
      <main-top-nav></main-top-nav>
      <flash-messenger-component></flash-messenger-component>
      <router-view class="bg-white h-100"></router-view>
      <version-component></version-component>
      <external-account-component></external-account-component>
    </v-main>
    <main-footer v-if="route.fullPath.includes('/account/')"></main-footer>
  </v-app>
</template>

<script setup lang="ts">
import MainTopNav from "../component/MainTopNavComponent.vue";
import MainFooter from "../component/MainFooterComponent.vue";
import ExternalAccountComponent from "../component/ExternalAccountComponent.vue";
import VersionComponent from "../component/VersionComponent.vue";
import { useRoute } from "vue-router";
import FlashMessengerComponent from "../component/FlashMessengerComponent.vue";

const route = useRoute();

</script>

